export default "__VITE_ASSET__1zqiep1A__"